import { render, staticRenderFns } from "./sealTest.vue?vue&type=template&id=9adca23c&scoped=true"
import script from "./sealTest.vue?vue&type=script&lang=js"
export * from "./sealTest.vue?vue&type=script&lang=js"
import style0 from "./sealTest.vue?vue&type=style&index=0&id=9adca23c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9adca23c",
  null
  
)

export default component.exports